import { State, TemplateStaff } from './types';

export default {
  setTemplateStaff(state: State, templateStaff: any[]) {
    const staff = templateStaff.map(staff => {
      return {
        id: staff.id,
        user: { email: staff.email },
        organization_user: staff.organization_user_details,
        role: staff.role_details
      } as TemplateStaff;
    });
    state.templateStaff = staff;
  },
  setIsTemplateStaffLoading(state: State, isLoading: boolean) {
    state.isTemplateStaffLoading = isLoading;
  },
  setTotalTemplateStaffCount(state: State, totalTemplateStaffCount: number) {
    state.totalTemplateStaffCount = totalTemplateStaffCount;
  },
  updateTemplateStaff(state: State, { staffId, staff }: { staffId: number; staff: any }) {
    state.templateStaff = state.templateStaff.map(staffMember => {
      if (staffMember.id === staffId) {
        return {
          ...staffMember,
          role: staff.role || staffMember.role,
          organization_user: {
            ...staffMember.organization_user,
            ...(staff.organization_user || {})
          }
        };
      }
      return staffMember;
    });
  },
  removeTemplateStaff(state: State, staffId: number) {
    state.templateStaff = state.templateStaff.filter(staff => staff.id !== staffId);
    state.totalTemplateStaffCount = state.templateStaff.length;
  }
};
